<template>
  <div id="app">
      <div class="body_bg">
        <div class="container pd15 whitebg">
          <el-row >
             <!-- <Mlogin/> -->
              <el-col :xs="24" :sm="24" :md="17" :lg="17" :xl="17">
             <div class="xbul">
               <ul>
                 <li style="margin-left:0 ;">
                   <a href="https://zkxb.csuft.edu.cn/" target="_blank">
                     <img src="../assets/images/zk_img.jpg" alt="">
                   <p style="color:#319885;">自然科学版学报</p>
                   </a>
                 </li>
                 <li>
                   <a href="https://skxb.csuft.edu.cn/" target="_blank">
                     <img src="../assets/images/sk_img.jpg" alt="">
                   <p style="color:#d19a20;">社会科学版学报</p>
                   </a>
                 </li>
                 <li>
                   <a href="https://jjlyj.csuft.edu.cn/" target="_blank">
                     <img src="../assets/images/jjl_img.jpg" alt="">
                   <p style="color:#4e4e4e;">经济林研究</p>
                   </a>
                 </li>
               </ul>
             </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
              <div class="tgxz fifth">
                        <div id="award">
                          <div class="titlebar">
                            <div class="title">
                              <span class="bottom_border">
                                <span>通知公告 </span>
                              </span>
                              <span class="title_more">
                                <router-link
                                  to="/NewsList"
                                >查看更多></router-link>
                              </span>
                            </div>
                          </div>
                          <Control
                            :params="{ ColumnId: 2, PageSize: 11 }"
                            :datelist="true"
                          ></Control>
                        </div>
                      </div>
            </el-col>
          </el-row>
        </div>
      </div>
<fileLoading></fileLoading>
  </div>
</template>
<script>
  import fileLoading from '../components/fileLoading'
  import Control from '../components/DocumentsNewsBlockControl/page/Control.vue'
  export default {
    data() {
      return {
        keywords:'',
        activeName: 'first',
        data:{},
        newList:[],
        List:[],
        Lista:[],
        isyuchuban:false,
        cotype:"",
        Periods: {},
        FileGUID:"",
        type:0,
        SetItem:{},
        isycb:false,
        isycba:false,
        isLoginDown:false,
        isEBt:false,
        newListTitle:"",
        recomList:[],
        recomLista:[],
        recomListb:[],
        recomListc:[],
        codeId:0,
        centerDialogVisible: false,
        CloumnList:[],
      }
    },
    components: {
    Control,
    fileLoading
    },
    created(){
      this.getArticList();
      this.GetIssue();
      this.getSet();      //获取系统配置
      this.GetRecomList(); //推荐列表
    },
    mounted(){
      if(this.$route.query.code){
        this.$store.dispatch("_getWeiXinLogin", {Scene: this.$route.query.code}).then(res=>{
             localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
       })
      }
       
    },
    methods: {
      getSet() {
          let params = [1000,1001,4530,6018,6019,230,6055,5000,5010,99,96,11,2960,2900,4553]
          //1000:期刊名称
          //1001：期刊英文名称
          //4530：（否）隐藏/（是）显示预出版模块
          //6018:预出版模块显示 （否）文章列表/（是）预出版内容
          //6019：是否需要登录下载文件
          //230：显示/隐藏所有的评论功能
          //6055：显示/隐藏列表和详情页的英文标题，英文关键字，英文摘要
          //5000： ISSN编号
          //5010：CN编号
          //11:是否启用手机短信
          //2900:是否启用英文网刊
          this.$store.dispatch("_getSet",params)
        .then(res => {
          this.SetItem=res.data.Data
          sessionStorage.setItem("SetItem",JSON.stringify(res.data.Data))
          this.SetItem.map((item)=>{
               if(item.SetItemID==4530){
               item.Item_Value=="是"?this.isycb=true:this.isycb=false
                }
                 if(item.SetItemID == 4553){
              this.printNum=item.Item_Value
            }
            if (item.SetItemID == 6018) {
              if (item.Item_Value == "是") {
                this._getLista(this.printNum);
              } else {
                this._getListb(this.printNum);
              }
            }
                if(item.SetItemID==6019){
               item.Item_Value=="是"?this.isLoginDown=true:this.isLoginDown=false
                }
              //   if(item.SetItemID==6055){
              //  item.Item_Value="是"?this.isEBt=true:this.isEBt=false
              //   }
          })
        }).catch(err => {
          console.log(err)
        })			
		
      },
        godigese(ids){
          this.$newOpen('/#/digest?ArticleID='+ids)
        },
      
      oniscode(num){
        this.centerDialogVisible=true
       this.codeId=num
      },
      handleClick(tab, event) {
        if(tab.index=="1"){
          this.type=1
          this.isyuchuban=true
          this.newList=this.Lista
        }
        if(tab.index=="0"){
            this.type=0
             this.isyuchuban=false
             this.newList=this.List
        }
      },
      getArticList() {
      let params = {
        PageSize: 0,
        IssueId: 0
      };
      this.$store
        .dispatch("_getNewlist", params)
        .then(res => {
          this.List = res.data.Data;
          this.Listb = res.data.Data;
          this.List.map(item=>{
            if(item.Column){
              this.CloumnList.push(item)
            }
          })
        })
        .catch(err => {
          console.log(err);
        });
    },
    goExport(ids){
      this.$newOpen('/#/Export?ids='+ids)
    },
      GetIssue() {
      this.$store
        .dispatch("_getYear", { Id: -1})
        .then(res => {
          this.newListTitle = res.data.Data.YearIssue_NoTtitle;
          let data={
            newYears:res.data.Data.Publish_Date,
            Volume:res.data.Data.Volume,
            CoverGUID:res.data.Data.CoverGUID,
            CoverSuffix:res.data.Data.CoverSuffix,
            YearIssue_NoTtitle:res.data.Data.YearIssue_NoTtitle
          }
          
          sessionStorage.setItem("newYears",JSON.stringify(data))
          this.Periods = res.data.Data;
        
        })
        .catch(err => {
          console.log(err);
        });
    },
    
	GetRecomList(){
			var time =new Date().getTime()
			let data = {
			  "PageSize":4,
        "Type":'Sort',
        "Key":"Recommended",
        "PageIndex":1
			}
			this.$store.dispatch("_getListb",data).then(res=>{
        if(res.data.IsSuccess){
          this.recomListc=res.data.Data
          for(let i=0;i<this.recomListc.length;i++){
            if(i<2){
              this.recomLista.push(this.recomListc[i])
            }else{
              this.recomListb.push(this.recomListc[i])
            }
          }
          this.recomList.push(this.recomLista)
          this.recomList.push(this.recomListb)
        }
        
      }).catch(err=>{
        console.log(err)
      })
		},
     pdf(i, size, guid) {
      let _this=this
      if (size <= 0) {
        alert("文件不存在");
        return;
      }
      this.$store.dispatch("_getPDF", { Id: guid }).then(Result => {
        window.location.href =  Result.request.responseURL;
      })
    },
    goHtml(url){
      window.open(url, "_blank");
    },
    _getLista(num) {
      var time = new Date().getTime();
      this.$store
        .dispatch("_getLista", {
          PageSize: num,
          src: time
        })
        .then(res => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data;
          }
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    _getListb(num) {
      var time = new Date().getTime();
      this.$store
        .dispatch("_getListb", {
          PageSize: num,
          Type: "Sort",
          Key: "Preprint",
          src: time
        })
        .then(res => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data;
          }
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
        
    }
  }
</script>

<style >
a{
  color: #222222;
}
.xbul ul li{
  float: left;
  margin: 15px;
}
@media (max-width:768px){
  .xbul ul li{
  margin: 15px;
  width: 100% !important;
  text-align: center;
}
}
.xbul ul li p{
  text-align: center;
  margin-top: 18px;
  font-size: 20px;
}

</style>
